import { render, staticRenderFns } from "./InputEditorCore.vue?vue&type=template&id=4945a735&scoped=true&"
import script from "./InputEditorCore.vue?vue&type=script&lang=js&"
export * from "./InputEditorCore.vue?vue&type=script&lang=js&"
import style0 from "./InputEditorCore.vue?vue&type=style&index=0&id=4945a735&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945a735",
  null
  
)

export default component.exports